import { useCallback } from 'react';

export function useTheme() {
  const isDark = false;

  if (typeof document !== "undefined") {
    document.documentElement.classList.remove('dark');
  }

  const toggleTheme = useCallback(() => {}, []);

  return { isDark, toggleTheme };
}
